import React from 'react';
import styles from './NoSiteSearchResults.module.scss';
import useBrand from '../../../../../hooks/useBrand';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';

export interface NoSiteSearchResultsProps
  extends React.HTMLAttributes<HTMLDivElement> {
  heading?: React.ReactNode;
  text?: React.ReactNode;
}

export function NoSiteSearchResults(props: NoSiteSearchResultsProps) {
  const { heading, text, ...restProps } = props;
  const { secondaryColor } = useBrand();
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: '40px' }} {...restProps}>
      <h4 style={{ color: secondaryColor }} className={styles.title}>
        {heading || t('site.search.heading')}
      </h4>
      <p className={styles.text}>{text || t('site.search.text')}</p>
    </Box>
  );
}
